/**
 * @class {SectionGiftQuiz.Questions}
 * @extends {SectionGiftQuiz}
 */
SectionGiftQuiz.Questions = Class(
	/**
	 * @lends {SectionGiftQuiz.Questions#}
	 */
	{
		__NAME: 'SectionGiftQuiz.Questions',

		bodyClass: 'small-nav small-nav-permanent hide-tablet-footer gift-quiz-page gift-quiz-questions-page',

		_steps: [],
		_questions: [],

		route() {
		},

		draw() {
			this._initQuestions();
			mkE({
				tag: 'div',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'gift-quiz-questions',
						els: [
							this._wizard = new T.Wizard({
								getSteps: this._getSteps,
								returnUrl: D.url('davanaman'),
								onStepChange: this._onStepChange
							})
						]
					}
				]
			}).append(this.layout.ct());
			this.ready();
		},

		_getSteps() {
			return this._steps;
		},

		_initQuestions() {
			let questions = [
				{
					question: 'Ja Tu būtu dzīvnieks, Tu būtu',
					answers: [
						{
							value: 8,
							caption: 'Ātrs suns'
						},
						{
							value: 4,
							caption: 'Vāvere'
						},
						{
							value: 3,
							caption: 'Pāvs'
						},
						{
							value: 5,
							caption: 'Kaķis'
						}
					]
				},
				{
					question: 'Frāze, kas vislabāk Tevi raksturo',
					answers: [
						{
							value: 2,
							caption: 'Sviests'
						},
						{
							value: 7,
							caption: 'Nē nu jā'
						},
						{
							value: 1,
							caption: 'Es taču teicu'
						},
						{
							value: 6,
							caption: 'Kā tad'
						}
					]
				},
				{
					question: 'Kādā krāsā ir tava aura?',
					answers: [
						{
							value: 0,
							caption: 'Izelpas krāsā'
						},
						{
							value: 0,
							caption: 'Vēja krāsā'
						},
						{
							value: 0,
							caption: 'Tāda pati kā vienradzim'
						},
						{
							value: 0,
							caption: 'Zila'
						}
					]
				},
				{
					question: 'Riņķa līnijā tev vislabāk patīk',
					answers: [
						{
							value: 0,
							caption: 'Iekšpuse'
						},
						{
							value: 0,
							caption: 'Ārpuse'
						},
						{
							value: 0,
							caption: 'Līnija'
						},
						{
							value: 0,
							caption: 'Centrs'
						}
					]
				},
				{
					question: 'Izvēlies tetovējumu',
					answers: [
						{
							value: 0,
							caption: 'Vārds, uzvārds'
						},
						{
							value: 0,
							caption: 'Liesmojošs skelets'
						},
						{
							value: 0,
							caption: 'Eņģeļtaurenis'
						},
						{
							value: 0,
							caption: 'Sliežu ceļu shēma'
						}
					]
				},
				{
					question: 'Esi iestrēdzis liftā. Ko darīsi pirmo?',
					answers: [
						{
							value: 0,
							caption: 'Uzņemšu videoselfiju'
						},
						{
							value: 0,
							caption: 'Sakārtošu fotogrāfijas telefonā'
						},
						{
							value: 0,
							caption: 'Raudāšu'
						},
						{
							value: 0,
							caption: 'Izlasīšu noteikumus 1823 reizes'
						}
					]
				},
				{
					question: 'Ja tu būtu Dievs, kādā krāsā tu būtu radījis čūskas?',
					answers: [
						{
							value: 0,
							caption: 'Pārsvarā brūnas un pelēkas'
						},
						{
							value: 0,
							caption: 'Gunmetal'
						},
						{
							value: 0,
							caption: 'Leoparda rakstā'
						},
						{
							value: 0,
							caption: 'Rose gold'
						}
					]
				},
				{
					question: 'Vieta, kur Tu jūties vislabāk',
					answers: []
				}
			];
			for (let i = 0, l = questions.length; i < l; i++) {
				let data = questions[i];
				data.base = this;
				let question = new SectionGiftQuiz.Questions.Question(data, i === 0, i === l - 1, this._save);
				this._questions.push(question);
				this._steps.push(question.getStep());
			}
		},

		_save() {
			let map = {
				1: 'expert',
				2: 'hunter',
				3: 'groupie',
				4: 'g-spot',
				5: 'explorer',
				6: 'detective',
				7: 'matchmaker',
				8: 'sprinter'
			};
			let value = this._questions[7]._value;
			let result = map[value];
			let prizes = this.gifts[result];
			this._shuffle(prizes);
			let prize = prizes[0];
			Section.navigate(D.url('davanaman/results/' + result + '/' + prize));
		},

		_shuffle(array) {
			for (let i = array.length - 1; i > 0; i--) {
				let j = Math.floor(Math.random() * (i + 1));
				[array[i], array[j]] = [array[j], array[i]];
			}
		},

		getPreviousAnswers() {
			return [
				this._questions[0]._value,
				this._questions[1]._value
			];
		}
	},
	SectionGiftQuiz
);

/**
 * @class {SectionGiftQuiz.Questions.Question}
 * @param {Object} par
 * @param {Boolean} isFirst
 * @param {Boolean} isLast
 * @param {Function} process
 */
SectionGiftQuiz.Questions.Question = Class(
	/**
	 * @lends {SectionGiftQuiz.Questions.Question#}
	 */
	{
		__NAME: 'SectionGiftQuiz.Questions.Question',
		_answers: [],
		_value: 0,

		/**
		 * @param {Object} par
		 * @param {Boolean} isFirst
		 * @param {Boolean} isLast
		 * @param {Function} process
		 * @constructs
		 */
		__construct(par, isFirst, isLast, process) {
			this.par = par;
			this.base = par.base;
			this.isFirst = isFirst;
			this.isLast = isLast;
			this._process = process;

			this.node = mkE({
				tag: 'div',
				className: 'quiz-question',
				els: [
					{
						tag: 'h2',
						text: par.question
					},
					this._answersNode = mkE({
						tag: 'div',
						className: 'quiz-answers'
					})
				]
			});
		},

		_select(index) {
			for (let i = 0, l = this._answers.length; i < l; i++) {
				if (i === index) {
					addClassName(this._answers[i], 'selected');
				} else {
					removeClassName(this._answers[i], 'selected');
				}
			}
			this._value = this.par.answers[index].value;
			this.getStep().setCanContinue(true);
		},

		getStep() {
			if (this._step) {
				return this._step;
			}
			this._step = new T.Wizard.Step({
				getContent: this.node,
				canGoBack: this.isFirst,
				continueText: this.isLast ? D.Lang.get('gift-quiz.test.finish') : '',
				continueAction: this.isLast ? this._process : null,
				onActivate: this._getAnswers
			});
			return this._step;
		},

		_drawAnswers() {
			for (let i = 0, l = this.par.answers.length; i < l; i++) {
				let answer = mkE({
					tag: 'div',
					className: 'quiz-answer',
					text: this.par.answers[i].caption,
					onclick: D.closure(this, this._select, i)
				}).append(this._answersNode);
				this._answers.push(answer);
			}
		},

		_getAnswers() {
			if (!this.isLast) {
				this._drawAnswers();
				return;
			}
			let previousAnswers = this.base.getPreviousAnswers();
			let answerMap = {
				4: 8,
				2: 7,
				3: 5,
				1: 6
			};
			let possibleAnswers = {
				8: [
					'Kupenā',
					'Pie psihoterapeita'
				],
				7: [
					'VIP ložā',
					'Zirga mugurā',
				],
				5: [
					'Afterpartijā',
					'Uz jumta'
				],
				6: [
					'Laboratorijā',
					'Alā'
				]
			};
			let answers = [];
			previousAnswers.forEach(answer => {
				let index = answerMap[answer] || answer;
				possibleAnswers[index].forEach(text => {
					answers.push({
						value: answer,
						caption: text
					});
				});
			});
			this.par.answers = answers;
			this._drawAnswers();
		}
	}
);
